import { Pipe, PipeTransform } from "@angular/core";
import { DefinizioneServizio } from "../models";

@Pipe({
  name: "sort"
})
export class ArraySortPipe  implements PipeTransform 
{
  transform(array: Array<DefinizioneServizio>): any[] {
    array.sort((a: DefinizioneServizio, b: DefinizioneServizio) => {
      return a.tipologiaServizio.descrizione.localeCompare(b.tipologiaServizio.descrizione);
    });
    return array;
  }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/pipes/sort-definizione-servizio.pipe.ts